"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smedium = exports.small = exports.medium = exports.large = exports.extraLarge = exports.base = void 0;
var _styledComponents = require("styled-components");
const base = exports.base = /*#__PURE__*/(0, _styledComponents.css)(["display:inline-block;fill:currentcolor;flex-shrink:0;"]);
const small = exports.small = /*#__PURE__*/(0, _styledComponents.css)(["width:8px;height:8px;"]);
const smedium = exports.smedium = /*#__PURE__*/(0, _styledComponents.css)(["width:12px;height:12px;"]);
const medium = exports.medium = /*#__PURE__*/(0, _styledComponents.css)(["width:16px;height:16px;"]);
const large = exports.large = /*#__PURE__*/(0, _styledComponents.css)(["width:22px;height:22px;"]);
const extraLarge = exports.extraLarge = /*#__PURE__*/(0, _styledComponents.css)(["width:32px;height:32px;"]);